<template>
  <div>
    <v-container class="pa-0 ma-0 fluid runner-ribbon" fill-height>
      <v-layout column>
        <v-card v-if="isRunner && runnersTrainer" class="pb-2 tri-bg" dark color="light-blue darken-3">
          <v-container class="pt-1 pb-0 px-4 fluid" color="primary">
            <v-layout row wrap justify-space-between>
              <v-flex class="d-inline-block runner-chooser">
                  <span class="headline mr-4">TRENER:</span>
                  <span class="d-inline-block">
                    <span class="title">
                      <router-link :to="{name: 'runner-trainer-data'}">
                        {{ runnersTrainer.first_name }} {{ runnersTrainer.last_name }}
                      </router-link>
                    </span>
                  </span>
              </v-flex>
              <v-flex v-if="!runner.account_paid" class="d-inline-block runner-chooser">
                  <span class="headline">konto nieopłacone!</span>
              </v-flex>
              <v-flex class="text-md-right runner-package">
                <span class="headline mr-4">PAKIET:</span>
                  <span class="title">{{ runner.package_name }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-layout>
    </v-container>
    <v-container class="pa-0 ma-0 fluid" fill-height>
      <v-layout column>
        <v-card v-if="isTrainer || isAdmin" dark color="light-blue darken-3" class="tri-bg">
          <v-container class="pt-1 pb-0 px-4 fluid" color="primary">
            <v-layout row wrap justify-space-between>
              <v-flex class="d-inline-block runner-chooser">
                  <span class="headline mr-4">ZAWODNIK:</span>
                  <span class="d-inline-block">
                    <v-btn flat class="upper" small icon v-tooltip="'poprzedni'" @click="prevRunner">
                      <v-icon>
                        keyboard_arrow_left
                      </v-icon>
                    </v-btn>
                    <span class="title">{{ runner.first_name }} {{ runner.last_name }} <span v-if="!runner.account_paid">(nieopłacony)</span></span>
                    <v-btn flat class='upper' small icon v-tooltip="'następny'" @click="nextRunner">
                      <v-icon>
                        keyboard_arrow_right
                      </v-icon>
                    </v-btn>
                  </span>
              </v-flex>
              <v-flex class="d-inline-block runner-mini-menu">
                <v-tabs fixed-tabs dark color="transparent">
                  <v-tab :to="{name: 'runner-data', params: {id: $route.params.id}}">
                    Dane
                  </v-tab>
                  <v-tab :to="{name: 'runner-plan', params: {id: $route.params.id}}">
                    Plan treningowy
                  </v-tab>
                  <v-tab :to="{name: 'runner-hrmax', params: {id: $route.params.id}}">
                    Badania
                  </v-tab>
                  <v-tab :to="{name: 'runner-progression', params: {id: $route.params.id}}">
                    Rekordy
                  </v-tab>
                  <v-tab :to="{name: 'runner-races', params: {id: $route.params.id}}">
                    Zawody
                  </v-tab>
                  <v-tab :to="{name: 'runner-payments', params: {id: $route.params.id}}">
                    Płatności
                  </v-tab>
                </v-tabs>
              </v-flex>
              <v-flex class="text-md-right runner-package">
                <span class="headline mr-4">PAKIET:</span>
                  <span class="title">{{ runner.package_name }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-layout>
    </v-container>
    <v-container fill-height :fluid="fluid">
      <v-layout>
        <v-flex>
          <router-view @runner-application-data-updated="rereadRunner"></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import * as types from '@/store/mutation-types'
import store from '@/store'

export default {
  props: {
    fluid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isTrainer', 'isRunner']),
    ...mapState(['runnersTrainer', 'runner', 'trainerRunners', 'adminRunners'])
  },
  created () {
    this.$store.dispatch(types.RUNNERS_TRAINER_REQUEST, store.state.runner).then(() => {
      if (this.isTrainer) {
        this.$store.dispatch(types.TRAINERS_RUNNERS_REQUEST, store.state.runnersTrainer)
      }
      if (this.isAdmin) {
        this.$store.dispatch(types.ADMIN_RUNNERS_REQUEST)
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
    store.dispatch(types.RUNNER_REQUEST, [to.params.id]).then((runner) => {
      let runnerSelf = store.getters.isRunner && runner.id === store.getters.authUser.id
      if (runnerSelf && !runner.data_filled &&
          to.name !== 'runner-application-data-package' &&
          to.name !== 'runner-application-data-trainer' &&
          to.name !== 'runner-application-data-first' &&
          to.name !== 'runner-application-data-second') {
        if (!runner.package) {
          return next({name: 'runner-application-data-package', params: {id: runner.id}})
        } else if (!runner.trainer) {
          return next({name: 'runner-application-data-trainer', params: {id: runner.id}})
        } else {
          return next({name: 'runner-application-data-first', params: {id: runner.id}})
        }
      } else if (runnerSelf && !runner.account_paid &&
          to.name !== 'runner-plan' &&
          to.name !== 'runner-payments' &&
          to.name !== 'runner-payments-pay' &&
          to.name !== 'runner-payments-return' &&
          to.name !== 'runner-application-data-package' &&
          to.name !== 'runner-application-data-trainer' &&
          to.name !== 'runner-application-data-first' &&
          to.name !== 'runner-application-data-second') {
        return next({name: 'runner-payments', params: {id: runner.id}})
      } else {
        return next()
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch(types.RUNNER_REQUEST, [to.params.id]).then((runner) => {
      let runnerSelf = store.getters.isRunner && runner.id === store.getters.authUser.id
      let trainerSelf = store.getters.isTrainer && runner.trainer === store.getters.authUser.id
      if (runnerSelf && !runner.data_filled &&
          to.name !== 'runner-application-data-package' &&
          to.name !== 'runner-application-data-trainer' &&
          to.name !== 'runner-application-data-first' &&
          to.name !== 'runner-application-data-second') {
        if (!runner.package) {
          return next({name: 'runner-application-data-package', params: {id: runner.id}})
        } else if (!runner.trainer) {
          return next({name: 'runner-application-data-trainer', params: {id: runner.id}})
        } else {
          return next({name: 'runner-application-data-first', params: {id: runner.id}})
        }
      } else if (runnerSelf && !runner.account_paid &&
          to.name !== 'runner-plan' &&
          to.name !== 'runner-payments' &&
          to.name !== 'runner-payments-pay' &&
          to.name !== 'runner-payments-return' &&
          to.name !== 'runner-application-data-package' &&
          to.name !== 'runner-application-data-trainer' &&
          to.name !== 'runner-application-data-first' &&
          to.name !== 'runner-application-data-second') {
        return next({name: 'runner-payments', params: {id: runner.id}})
      }
      if (store.getters.isAdmin ||
         (trainerSelf) ||
         (runnerSelf)) {
        return next()
      } else {
        return next({name: 'login'})
      }
    })
  },
  methods: {
    rereadRunner () {
      store.dispatch(types.RUNNER_REQUEST, [this.runner.id, true])
    },
    nextRunner () {
      let runners = this.isAdmin ? this.adminRunners : this.trainerRunners
      let newIndex
      let index = runners.findIndex((elem) => {
        return this.runner.id === elem.id
      })
      if (index < 0) {
        return
      }
      if (index === runners.length - 1) {
        newIndex = 0
      } else {
        newIndex = index + 1
      }
      this.$router.push({name: this.$route.name, params: {id: runners[newIndex].id}})
    },
    prevRunner () {
      let runners = this.isAdmin ? this.adminRunners : this.trainerRunners
      let newIndex
      let index = runners.findIndex((elem) => {
        return this.runner.id === elem.id
      })
      if (index < 0) {
        return
      }
      if (index === 0) {
        newIndex = runners.length - 1
      } else {
        newIndex = index - 1
      }
      this.$router.push({name: this.$route.name, params: {id: runners[newIndex].id}})
    }
  }
}
</script>
<style>

  .tri-bg {
      background-image: url('../assets/img/trianglify-max.jpg');
      background-repeat: repeat;
  }
  .runner-ribbon a {
    color: white;
  }
  .v-btn.upper {
    margin-bottom: 12px;
  }
  @media(max-width: 1800px) {
    .runner-mini-menu {
      flex: 0 0 100%;
      order: 4;
    }
  }
  @media(max-width: 960px) {
    .runner-choosed {
      flex: 0 0 100%;
    }
    .runner-package {
      flex: 0 0 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layouts/RunnerPanelLayout.vue